import React from 'react'
import { Translate } from '../../language';

const CertificateAccount = ({ history }) => {
    return (
        <div>
            <div className="edit-info-tittle">
                <div className="circle-gray-edit-info"></div>
                {Translate('certificateAccount', 'es')}
            </div>

            <div className="certificate-container">
                <div className='certificate-message'>{Translate('messageCertificate', 'es')}</div>
                <div onClick={() => history.push('/CertificateAccountData')} className="btn-certificate-profile pointer">{Translate('continue', 'es')}</div>
            </div>
        </div>
    )
}

export default CertificateAccount
